import {IDateTimeWithZone} from '../common/date-time-with-zone.interface';
import {ObservationType} from './observation.class';
import {DocumentEntityType} from '../message-models/document-entity-type.enum';
import {DateTimeWithZone} from '../common/date-time-with-zone.class';
import {IObservationSummary} from '../message-models/observation-summary.interface';

export class ObservationSummary implements IObservationSummary {
  observationId: string;
  summaryInfo: string;
  notesAsHtml: string;
  observedBy: string;
  observedOn: IDateTimeWithZone;
  followUpOn: IDateTimeWithZone;
  observationType: ObservationType;
  createdOn: Date;
  operativeId: string;
  operativeName: string;
  operativeFirstName: string;
  operativeLastName: string;
  companyId: string;
  companyName: string;
  documentId: string;
  documentObservationId: string;
  operativeObservationId: string;
  trainingRecordId: string;
  trainingRecordObservationId: string;
  companyObservationId: string;
  companyDocumentId: string;
  // observationTypeString: string;
  constructor(iObservationSummary: IObservationSummary) {
    this.observationId = iObservationSummary?.observationId || '00000000-0000-0000-0000-000000000000';
    this.summaryInfo = iObservationSummary?.summaryInfo || '';
    this.notesAsHtml = iObservationSummary?.notesAsHtml || '';
    this.observedBy = iObservationSummary?.observedBy || '';
    this.observedOn = iObservationSummary?.observedOn || new DateTimeWithZone(iObservationSummary?.observedOn) || new DateTimeWithZone({} as IDateTimeWithZone);
    this.followUpOn = iObservationSummary?.followUpOn || new DateTimeWithZone(iObservationSummary?.followUpOn) || new DateTimeWithZone({} as IDateTimeWithZone);
    this.observationType = iObservationSummary?.observationType || null;
    this.operativeId = iObservationSummary?.operativeId || '00000000-0000-0000-0000-000000000000';
    this.operativeName = iObservationSummary?.operativeName || '';
    this.operativeFirstName = iObservationSummary?.operativeFirstName || '';
    this.operativeLastName = iObservationSummary?.operativeLastName || '';
    this.companyId = iObservationSummary?.companyId || '00000000-0000-0000-0000-000000000000';
    this.companyName = iObservationSummary?.companyName || '';
    this.documentId = iObservationSummary?.documentId || '00000000-0000-0000-0000-000000000000';
    this.documentObservationId = iObservationSummary?.documentObservationId || '00000000-0000-0000-0000-000000000000';
    this.operativeObservationId = iObservationSummary?.operativeObservationId || '00000000-0000-0000-0000-000000000000';
    this.trainingRecordId = iObservationSummary?.trainingRecordId || '00000000-0000-0000-0000-000000000000';
    this.trainingRecordObservationId = iObservationSummary?.trainingRecordObservationId || '00000000-0000-0000-0000-000000000000';
    this.companyObservationId = iObservationSummary?.companyObservationId || '00000000-0000-0000-0000-000000000000';
    this.companyDocumentId = iObservationSummary?.companyDocumentId || '00000000-0000-0000-0000-000000000000';
    this.createdOn = iObservationSummary?.createdOn || null;
    // this.observationTypeString = iObservationSummary?.observationTypeString || '';
  }
}
